import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'orderStatusName',
    standalone: false
})
export class OrderStatusNamePipe implements PipeTransform {
  transform(orderStatus: string): string {
    switch (orderStatus) {
      case 'Unassigned':
        return 'Ikke tildelt';
      case 'Offer':
        return 'Tildelt';
      case 'Accepted':
        return 'Akseptert'
      case 'Rejected':
        return 'Avvist';
      case 'Started':
        return 'Påbegynt';
      case 'Finished':
        return 'Fullført';
      case 'Registered':
      case 'Expired':
        return 'Registrert';
      default:
        return orderStatus;
    }
  }
}
